import { RefObject, useLayoutEffect, useState } from "react";

export const useTruncatedElement = (ref: RefObject<HTMLDivElement | null>, maxCollapsedHeight: number | null) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const [isShowingLess, setIsShowingLess] = useState(true);

  const checkIfTruncated = () => {
    const { offsetHeight, scrollHeight, offsetWidth, scrollWidth } = ref?.current || {};
    let isContentOverflowing = offsetHeight && scrollHeight && offsetHeight < scrollHeight;
    if (maxCollapsedHeight && scrollHeight && maxCollapsedHeight <= scrollHeight) {
      isContentOverflowing = true;
    }
    setIsTruncated(!!isContentOverflowing);
    if (!isContentOverflowing) {
      ref.current?.classList.remove("collapsed");
      ref.current?.classList.remove("expanded");
      setIsShowingLess(true);
    }
  };

  useLayoutEffect(() => {
    checkIfTruncated();
    window.addEventListener("resize", checkIfTruncated);

    return () => {
      window.removeEventListener("resize", checkIfTruncated);
    };
  }, [ref]);

  const toggleIsShowingMore = () => {
    if (isShowingLess) {
      ref.current?.classList.remove("collapsed");
      ref.current?.classList.add("expanded");
    } else {
      ref.current?.classList.add("collapsed");
      ref.current?.classList.remove("expanded");
    }
    setIsShowingLess((prev) => !prev);
  };

  return {
    isTruncated,
    isShowingLess,
    toggleIsShowingMore,
  };
};
